/**
 * Класс для попапа, который появляется перед заказом.
 * Строит html для модулей в попапе, добавляет цены, использует функцию кропа прозрачных картинок через ajax
 * */
export default class PreOrderPopup {
  constructor(configurator) {
    this.sofa = configurator.sofa
  }

  /**
   * Заносит все данные из state и тканей в попап, строит html для модулей
   * */
  build() {
    let object = this.sofa
    let containerEl = $('.js-pre-order-content.scroll-content')
    let containerModulesEl = containerEl.find('.js-pre-order-module-content')
    let moduleEl = containerEl.find('.js-pre-order-module').eq(0).clone()
    let moduleImages = []

    containerModulesEl.find('.js-pre-order-module').remove()

    this.sofa.state.forEach((item) => {
      let img = object.sections[item.id]['image']['front']['src'];
      if(img !== '' && typeof img !== "undefined") {
        moduleImages.push(img)
      }
      else {
        let imgEl = $('[data-connected="' + object.sections[item.id]['connected_module'] + '"]').eq(0).find('img')
        moduleImages.push(imgEl.attr('src'))
      }
    })

    /*вызываем функцию для кропа изображений модулей, в коллбек вешаем построение html*/
    this.getCroppedImages($('#pre-order-table'), moduleImages, (response) => {
      this.sofa.state.forEach((item, index) => {
        let moduleImage = response[index]
        let moduleName = object.sections[item.id]['name']
        let moduleWidth = object.sections[item.id]['sizes']['x']
        let moduleDepth = object.sections[item.id]['sizes']['y']
        let moduleHeight = object.sections[item.id]['sizes']['z']
        let modulePrice = object.helpers.formattedPrice(object.sections[item.id].price)

        let newModuleEl = moduleEl.clone()
        let moduleImageEl = newModuleEl.find('.js-pre-order-module-image')
        let moduleNameEl = newModuleEl.find('.js-pre-order-module-name')
        let moduleWidthEl = newModuleEl.find('.js-pre-order-module-width')
        let moduleDepthEl = newModuleEl.find('.js-pre-order-module-depth')
        let moduleHeightEl = newModuleEl.find('.js-pre-order-module-height')
        let modulePriceEl = newModuleEl.find('.js-pre-order-module-price')

        moduleImageEl.attr('src', moduleImage)
        moduleNameEl.text(moduleName)
        moduleWidthEl.text(moduleWidth)
        moduleDepthEl.text(moduleDepth)
        moduleHeightEl.text(moduleHeight)
        modulePriceEl.text((parseInt(modulePrice.replace(' ',''))*PL_CURRENCY).format(0, 3, ' ', ','))

        containerModulesEl.prepend(newModuleEl)
      })

      moduleEl.remove();

      let materialSofaImageEl = containerEl.find('.js-pre-order-material-sofa-image')
      let materialSofaNameEl = containerEl.find('.js-pre-order-material-sofa')
      let materialPillowsImageEl = containerEl.find('.js-pre-order-material-pillows-image')
      let materialPillowsNameEl = containerEl.find('.js-pre-order-material-pillows')
      let preOrderTotalPrice = $('.js-pre-order-total-price')

      let materialSofa = $('.js-material-cat-item:not(.js-material-pillows)').find('.js-material-item.is-current')
      let materialSofaImage = materialSofa.find('img').attr('src')
      let materialSofaName = materialSofa.data('material-true-name') + ' ' + materialSofa.data('material-color')
      let materialPillows = $('.js-material-pillows').find('.js-material-pillow-item.is-current')
      let materialPillowsImage = materialPillows.find('img').attr('src')
      let materialPillowsName = materialPillows.data('material-true-name') + ' ' + materialPillows.data('material-color')
      let totalPrice = $('.js-configurator-price').text()

      materialSofaImageEl.attr('src', materialSofaImage)
      materialSofaNameEl.text(materialSofaName)
      materialPillowsImageEl.attr('src', materialPillowsImage)
      materialPillowsNameEl.text(materialPillowsName)
      preOrderTotalPrice.text(totalPrice)
    })
  }

  /**
   *Обрабатывает массив изображений (путей к ним), возвращает кропнутые, без прозрачных полей в base64
   * @param {jQuery} container - контейнер к которому применять класс загрузки
   * @param {Array} images - массив путей к картинкам
   * @param {function} callback - функция, которая выполняется на success, принимает response
   * */
  getCroppedImages(container, images, callback) {
    $.ajax({
      url: ajaxurl,
      dataType: 'json',
      type: 'post',
      data: {
        action: 'get_cropped_images',
        images: images
      },

      beforeSend: () => {
        container.addClass('loading')
      },

      success: (response) => {
        callback(response)
      },

      complete: () => {
        container.removeClass('loading')
      }
    })
  }
}